// Display helpers: money, dates, decimals-as-strings.

export function money(value: string | number | null | undefined, currency = 'USD', locale = 'en'): string {
  if (value === null || value === undefined || value === '') return '—';
  const n = typeof value === 'number' ? value : Number(value);
  if (Number.isNaN(n)) return String(value);
  return new Intl.NumberFormat(locale === 'fr' ? 'fr-FR' : 'en-US', { style: 'currency', currency, maximumFractionDigits: currency === 'USD' ? 4 : 2 }).format(n);
}

export function usd(value: number | string | null | undefined, locale = 'en'): string {
  return money(value, 'USD', locale);
}

/** The usage ledger's amounts (credit grants, what calls are worth, the staff credits view): euros, to the cent.
 * Prices, pools and caps shown for an offer, a pack or an organization are in its currency: use `money`. */
export function eur(value: number | string | null | undefined, locale = 'en'): string {
  return money(value, 'EUR', locale);
}

/** An offer or a pack as staff name it: its key repeats across currencies, so the currency goes with it. */
export function keyIn(key: string, currency: string): string {
  return `${key} · ${currency}`;
}

export function dateTime(iso: string | null | undefined, locale = 'en'): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(locale === 'fr' ? 'fr-FR' : 'en-GB', { dateStyle: 'medium', timeStyle: 'short' }).format(d);
}

export function dateOnly(iso: string | null | undefined, locale = 'en'): string {
  if (!iso) return '—';
  const d = new Date(iso.length === 10 ? `${iso}T00:00:00` : iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat(locale === 'fr' ? 'fr-FR' : 'en-GB', { dateStyle: 'medium' }).format(d);
}

/** A decimal string for the API from a form input; null when blank. */
export function toDecimal(input: string): string | null {
  const t = input.trim().replace(',', '.');
  if (!t) return null;
  const n = Number(t);
  return Number.isNaN(n) ? null : n.toFixed(2);
}

export function lineTotal(quantity: string | number, unitPrice: string | number): number {
  const q = Number(quantity);
  const p = Number(unitPrice);
  return Number.isNaN(q) || Number.isNaN(p) ? 0 : q * p;
}

export function fullName(first: string, last: string, fallback = ''): string {
  return `${first} ${last}`.trim() || fallback;
}
